import React from 'react'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

const Circle = styled('circle')(({ theme }) => ({
  '&#dot1': {
    animation: `load 1s infinite`,
  },
  '&#dot2': {
    animation: 'load 1s infinite',
    animationDelay: '0.2s',
  },
  '&#dot3': {
    animation: `load 1s infinite`,
    animationDelay: '0.4s',
  },
  '@keyframes load': {
    '0%': {
      opacity: 0,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0,
    },
  },
}))

const ThreeDotsLoadingSpinner = props => {
  const { width, height, fillColor } = props
  return (
    <Box sx={{ width, height }}>
      <svg id="dots" viewBox="0 0 132 58" version="1.1">
        <defs></defs>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="dots" fill={fillColor ? fillColor : '#0099FF'}>
            <Circle id="dot1" cx="25" cy="30" r="13"></Circle>
            <Circle id="dot2" cx="65" cy="30" r="13"></Circle>
            <Circle id="dot3" cx="105" cy="30" r="13"></Circle>
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default ThreeDotsLoadingSpinner
